@if (isSelected()) {
<div>
    @if (packOptionId !== undefined) {
    <p class="p1 m-b-2">
        {{'Based on a purchase price of £% and 10% deposit, the following finance plans are available (subject to affordability, age and status)'
            | translate : info?.totalAmount : '%' }}
    </p>
    }

    <div class="w-12 p-t-3 p-b-3"
         [grid]="2"
         [gridColumnGap]="'12px'"
         [gridRowGap]="'12px'">
        @for (packOption of packOptions; track trackByPackId($index, packOption)) {
        <button class="p2 center p-r-2 p-l-2 p-t-6 p-b-6 _option"
                [ngClass]="packOptionId === packOption.id ? 'col-w bg-col-6' : 'col-1 bg-col-5'"
                (click)="selectPackOption(packOption.id)">
            {{packOption.title}}
            <div class="m-t-2 _option-price">
                <price [value]="getMonthlyPriceForPackOption(packOption)"
                       [precision]="2" />&nbsp;<span class="p2">p/m</span>
            </div>
        </button>
        }
    </div>

    @if (info) {
    <ul class="block m-b">
        @for (item of infoItems; track trackByInfoItemTitleValue(index, item); let even = $even; let index = $index) {
        <li class="flex flex-justify-between p-a-2"
            [class.bg-col-5]="even">
            <span class="s2 no-wrap">
                {{item.title}}
            </span>
            @if (!item.isPrice) {
            <span class="p2 right"
                  [ngClass]="{'w-7-s' : index === 0}">
                {{item.value}}
            </span>
            }
            @if (item.isPrice) {
            <price class="p2 right"
                   [value]="asNumber(item.value)"
                   [precision]="2"></price>
            }
        </li>
        }
    </ul>
    }
    <v12-retail-finance-info />
</div>
}